/**
 * Created by mi on 24.3.17.
 */

export const TRANSITION = "app/TRANSITION";
export const LOADING = "app/LOADING";
export const LOADED = "app/LOADED";
export const AUTOLOAD = "app/AUTOLOADED";
